<template>
  <section class="register-container">
    <div class='login-wrap'>
      <h1>《北大法律评论》官网注册章程</h1>
      <p>一、关于投稿</p>
      <p>1.通过本网站投递的稿件必须为作者独立研究完成，充分尊重他人知识产权，遵守基本学术规范，无任何违反法律、法规、出版纪律和学术道德的内容；文中引文、注释和其他资料，应逐一核对原文，确保准确无误；如使用转引资料，应注明转引出处。</p>
      <p>2. 《北大法律评论》编委会（下称“编委会”）对稿件进行初审、报送匿名评审、复审、校对等编辑工作，但稿件由作者文责自负。</p>
      <p>3. 通过本网站向编委会投递的稿件，应确保未一稿多发，且稿件主要观点或基本内容，不得先于《北大法律评论》在其他公开或内部出版物（包括但不限于学术期刊、报纸、杂志、专著、论文集、学术网站等）上发表。</p>
      <p>4.《北大法律评论》实行双向匿名审稿制度。所投稿件正文中请勿出现作者个人信息，行文也请避免使用可能透露作者身份的信息。</p>
      <p>5.通过本网站向编委会投递的稿件，一经录用，稿件的复制权、发行权、汇编权及信息网络传播权等必要的著作财产权将让予编委会。作者如需将《北大法律评论》已录用的稿件于其他公开出版物中刊登，须事先征得编委会同意，并详细注明该文原载卷辑。作者如就所《北大法律评论》录用稿件接受媒体采访，应对相关言论负责。作者对此如有异议或有其他特殊要求，请与编委会协商。</p>
      <p>6.编委会有权对来稿做文字表述修改及其他技术性的修改。本刊审稿时长一般不少于30日，编审过程可全流程在本网站查询。</p>
      <p>二、隐私政策</p>
      <p>1.本网站可能搜集的信息</p>
      <p>基于稿件编审等相关工作需要，本网站可能会要求您提供姓名、性别、联系方式、电子邮箱、学位、职称、研究方向、所在单位等信息。</p>
      <p>部分服务可能需要您提供身份证号码、通讯地址、照片等个人敏感信息。若您选择不提供这些信息，则可能无法正常使用服务中的特定功能。若您主动提供您的个人敏感信息，即表示您同意我们按本政策所述目的和方式来处理您的个人敏感信息。</p>
      <p>2.所搜集信息的使用</p>
      <p>上述信息一经收集，我们会严格遵守法律法规的规定和本隐私政策所载承诺，将信息用于如下用途。如果超出下列范围使用信息，我们会事先征得您的同意。</p>
      <p>（1）提供服务，包括审稿、校对、出版、稿件全流程进度查询、样刊邮寄等；</p>
      <p>（2）安全保障。例如，我们会将您的信息用于身份验证、安全防范、存档备份等用途，以保护您和我们的其他用户的合法权益。</p>
      <p>3.信息的第三方共享</p>
      <p>未经您同意，我们不会向任何第三方提供所收集的信息，但如下情形除外：</p>
      <p>（1）基于法律法规相关规定，由法定机关调取或要求强制性提供的；</p>
      <p>（2）在法律法规允许的范围内，为保障您的合法权益或其他用户社会公众的合法权益免受侵害。</p>
      <p>4.本网站可能采用的技术</p>
      <p>本网站可能会通过Cookie技术收集、使用并存储您的信息，其目的是：</p>
      <p>（1）识别并保存您的身份，包括您作为作者、评审专家、网站维护人员等个人或单位身份；</p>
      <p>（2）向您开放您申请且有权限访问的模块、区域，包括公共区域、作者投稿平台、评审专家工作台、网站维护等模块、区域；</p>
      <p>（3）维护网站安全，我们将通过Cookie技术识别、记录、追踪各类有风险的访问活动，并以此实施监控网站运行，确保您在我们网站的各类活动的安全。</p>
      <p>您可以通过浏览器的Cookie设置关闭本网站的Cookie访问权限，但您所拥有的权限将因此受到相应限制。</p>
      <p>5.隐私政策可由编委会根据国家法律政策、技术发展等因素加以修订。若您继续使用我们的服务，即表示您同意受修订后的隐私政策的约束。</p>
      <p>三、网站使用</p>
      <p>1.禁止行为</p>
      <p>（1）任何用户不得通过“网络爬虫”“深层链接”等自动设备、程序、算法以及其他方法抓取、下载、存储、共享本网站任何数据；</p>
      <p>（2）任何用户不得通过IP隐藏、伪装IP等规避网站权限设置的技术访问本网站，并不得作出超出自己权限范围的浏览、修改、删除、下载、泄漏等行为；</p>
      <p>（3）任何无授权用户不得运用各种手段识别并利用网站漏洞；</p>
      <p>（4）法律法规、国家政策和北京大学相关政策禁止的其他侵权、违法或犯罪行为。</p>
      <p>2.提示行为</p>
      <p>（1）任何用户共享、出售个人账号与密码等行为将是不被提倡的，如果您是受邀请的评审专家、网站维护人员等带有特定权限的身份，那么以上行为将被禁止；</p>
      <p>（2）任何用户使用同一身份在多台设备上访问本网站将是不被提倡的，如果借助身份同时登录行为从事侵权、违法或犯罪活动，本网站保留追究其法律责任的权利。</p>
      <p>四、其他</p>
      <p>1.编委会工作邮箱为：<a href="mailto:pkulawrev@gmail.com">pkulawrev@gmail.com</a>，如遇本网站技术故障等特殊情形，可通过上述邮箱联系编委会。<strong>稿件投递、返修等与稿件相关事项，均通过本网站进行，请勿通过上述邮箱。</strong></p>
      <p>2.编委会工作地址为：北京市海淀区颐和园路5号北京大学法学院凯原楼311科研中心《北大法律评论》编委会。</p>
      <p>3.其他未尽事宜由编委会决定。</p>
    </div>
  </section>
</template>
<script>

export default {
  name: 'agree',
  components: {
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>
<style lang="scss">
.register-container{
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color:#F2F6F7;
  padding-top: 50px;
  padding-bottom: 50px;
  box-sizing: border-box;
  position: relative;
  .login-wrap{
    position: relative;
    width: 920px;
    background-color: #ffffff;
    box-shadow:0px 5px 50px 0px rgba(51,51,51,0.1);
    border-radius:8px;
    padding: 30px;
    box-sizing: border-box;
    h1 {
      font-size: 30px;
      text-align: center;
      line-height: 50px;
    }
    p {
      font-size: 14px;
      line-height: 28px;
      a {
        text-decoration: underline;
      }
      strong {
        font-weight: bold;
      }
    }
  }
}
</style>
